<app-property-map
  [propertiesData]="properties()"
  [mapHeight]="'800px'"
  [radiusDrawInfo]="mapRadiusDrawInfo"
  (popupCardClick)="openApplyPage($event)"
  [tileServerUrl]="tileServerUrl$ | async"
></app-property-map>
<!-- setting a non-relative height for map fixes issue with map‘s interaction with iframe's auto sizing -->
